import { useCallback } from 'react';
import { auth } from '@/lib/firebase';
import { toast } from 'sonner';
import { useSetAtom } from 'jotai';
import { dockerImagesAtom, dockerImagesErrorAtom, dockerImagesLoadingAtom } from './atoms';

export const useDockerImages = () => {
  const setImages = useSetAtom(dockerImagesAtom);
  const setLoading = useSetAtom(dockerImagesLoadingAtom);
  const setError = useSetAtom(dockerImagesErrorAtom);

  const fetchDockerImages = useCallback(async (): Promise<void> => {
    const user = auth.currentUser;

    setLoading(true);
    setError(null);

    try {
      if (!user) return;

      const idToken = await user.getIdToken();
      const response = await fetch('/api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ action: 'images' }),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch Docker images: ${response.status}`);
      }

      const { data } = await response.json();

      if (data?.images) {
        setImages(data.images);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch Docker images';
      toast.error(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    fetchDockerImages,
  };
};
